// import React, { useState, useEffect } from 'react';
// import { 
//   Container, Typography, Box, Chip, Paper, Breadcrumbs, 
//   Link as MuiLink, CircularProgress, Grid, Divider, List, 
//   ListItem, ListItemText, Avatar, Stack, IconButton, 
//   TextField, Button, Alert, useTheme 
// } from '@mui/material';
// import { Link, useParams } from 'react-router-dom';
// import NavigateNextIcon from '@mui/icons-material/NavigateNext';
// import ReactMarkdown from 'react-markdown';
// import remarkGfm from 'remark-gfm';
// import rehypeRaw from 'rehype-raw';
// import ShareIcon from '@mui/icons-material/Share';
// import FacebookIcon from '@mui/icons-material/Facebook';
// import TwitterIcon from '@mui/icons-material/Twitter';
// import LinkedInIcon from '@mui/icons-material/LinkedIn';
// import EmailIcon from '@mui/icons-material/Email';
// import SearchIcon from '@mui/icons-material/Search';
// import SEO from '../SEO';

// const BlogPost = () => {
//   const { slug } = useParams();
//   const theme = useTheme();
//   const [post, setPost] = useState(null);
//   const [loading, setLoading] = useState(true);
//   const [recentPosts, setRecentPosts] = useState([]);
//   const [emailSubscribed, setEmailSubscribed] = useState(false);
//   const [isVideoPost, setIsVideoPost] = useState(false);

  
   
//   useEffect(() => {
//     const savedPosts = localStorage.getItem('freshsweeper_blog_posts');
//     if (savedPosts) {
//       const posts = JSON.parse(savedPosts);
//       const foundPost = posts.find(p => p.slug === slug);
//       setPost(foundPost);
      
//       // Check if post contains YouTube video
//       if (foundPost && foundPost.content) {
//         const hasYouTube = foundPost.content.includes('youtube.com/embed') || 
//                           foundPost.content.includes('youtu.be') ||
//                           foundPost.content.includes('youtube.com/watch');
//         setIsVideoPost(hasYouTube);
//       }
      
//       const recent = posts.filter(p => p.slug !== slug).slice(0, 5);
//       setRecentPosts(recent);
//     }
//     setLoading(false);
//   }, [slug]);

//   useEffect(() => {
//     if (post) {
//       document.title = `${post.title} | FreshSweeper Blog`;
//       const metaDescription = document.querySelector('meta[name="description"]');
//       if (metaDescription) {
//         metaDescription.setAttribute('content', post.excerpt || post.content.substring(0, 150));
//       }
//     }
//   }, [post]);

//   const formatDate = (dateString) => {
//     const options = { year: 'numeric', month: 'long', day: 'numeric' };
//     return new Date(dateString).toLocaleDateString(undefined, options);
//   };

//   const handleShare = () => {
//     navigator.clipboard.writeText(window.location.href);
//     alert('Link copied to clipboard!');
//   };

//   const handleSubscribe = () => {
//     setEmailSubscribed(true);
//     setTimeout(() => setEmailSubscribed(false), 3000);
//   };

//   const YouTubeEmbed = ({ url }) => {
//     const getVideoId = (url) => {
//       const regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=)([^#&?]*).*/;
//       const match = url.match(regExp);
//       return (match && match[2].length === 11) ? match[2] : null;
//     };
  
//     const videoId = getVideoId(url);
//     if (!videoId) return null;
  
//     return (
//       <Box sx={{ position: 'relative', paddingBottom: '56.25%', height: 0, mb: 3, my: 4 }}>
//         <iframe
//           src={`https://www.youtube.com/embed/${videoId}`}
//           title="YouTube video player"
//           frameBorder="0"
//           allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
//           allowFullScreen
//           style={{
//             position: 'absolute',
//             top: 0,
//             left: 0,
//             width: '100%',
//             height: '100%',
//             borderRadius: '12px'
//           }}
//         />
//       </Box>
//     );
//   };

//   if (loading) {
//     return (
//       <Container sx={{ py: 8, textAlign: 'center' }}>
//         <CircularProgress />
//       </Container>
//     );
//   }

//   if (!post) {
//     return (
//       <Container sx={{ py: 8, textAlign: 'center' }}>
//         <Typography variant="h4" gutterBottom>Post Not Found</Typography>
//         <Typography color="text.secondary">The blog post you're looking for doesn't exist.</Typography>
//         <MuiLink component={Link} to="/blog" sx={{ mt: 2, display: 'inline-block' }}>← Back to Blog</MuiLink>
//       </Container>
//     );
//   }

//   // Safely access theme colors
//   const primaryColor = theme?.palette?.primary?.main || '#3b82f6';
//   const textPrimary = theme?.palette?.text?.primary || '#111827';
//   const textSecondary = theme?.palette?.text?.secondary || '#6b7280';

//   return (

//     <>
//       {/* ✅ SEO component placed here – before the visual content */}
//       <SEO 
//         title={post.title}
//         description={post.excerpt || post.content.substring(0, 150).replace(/<[^>]*>/g, '')}
//         image={post.image}
//         type="article"
//         canonical={`https://freshsweeper.com/blog/${post.slug}`}
//       />

//     <Container maxWidth="xl" sx={{ py: 4 }}>
//       <Breadcrumbs separator={<NavigateNextIcon fontSize="small" />} sx={{ mb: 3 }}>
//         <MuiLink component={Link} to="/" color="inherit">Home</MuiLink>
//         <MuiLink component={Link} to="/blog" color="inherit">Blog</MuiLink>
//         <Typography color="text.primary">{post.title}</Typography>
//       </Breadcrumbs>

//       <Grid container spacing={4}>
//         {/* Main Content Column */}
//         <Grid item xs={12} md={8}>
//           <Paper sx={{ p: 4, borderRadius: 3 }}>
//             <Chip label={post.category} sx={{ mb: 2 }} />
//             <Typography variant="h3" sx={{ fontWeight: 800, mb: 2 }}>
//               {post.title}
//             </Typography>
            
//             <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 3, flexWrap: 'wrap' }}>
//               <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
//                 <Avatar sx={{ width: 32, height: 32, bgcolor: primaryColor }}>
//                   {post.author?.charAt(0) || 'F'}
//                 </Avatar>
//                 <Typography variant="body2">By {post.author || 'FreshSweeper Team'}</Typography>
//               </Box>
//               <Typography variant="body2" color="text.secondary">•</Typography>
//               <Typography variant="body2" color="text.secondary">{formatDate(post.date)}</Typography>
//               <Typography variant="body2" color="text.secondary">•</Typography>
//               <Typography variant="body2" color="text.secondary">5 min read</Typography>
//             </Box>
            
//             {/* Only show featured image if it's NOT a video post */}
//             {!isVideoPost && post.image && (
//               <Box
//                 component="img"
//                 src={post.image}
//                 alt={post.title}
//                 sx={{ width: '100%', borderRadius: 2, mb: 4 }}
//               />
//             )}
            
//             {/* Show video placeholder or icon for video posts */}
//             {/* {isVideoPost && (
//               <Box sx={{ 
//                 mb: 4, 
//                 p: 4, 
//                 bgcolor: '#f3f4f6', 
//                 borderRadius: 2, 
//                 textAlign: 'center',
//                 border: `1px solid ${primaryColor}20`
//               }}>
//                 <Box sx={{ fontSize: 48, mb: 1 }}>🎥</Box>
//                 <Typography variant="body2" color="text.secondary">
//                   Video tutorial below
//                 </Typography>
//               </Box>
//             )} */}
            
//             <Box sx={{ 
//               '& h1': { fontSize: '2.5rem', fontWeight: 700, mb: 2 },
//               '& h2': { fontSize: '2rem', fontWeight: 700, mt: 4, mb: 2 },
//               '& h3': { fontSize: '1.5rem', fontWeight: 600, mt: 3, mb: 1.5 },
//               '& p': { lineHeight: 1.8, mb: 2 },
//               '& ul, & ol': { mb: 2, pl: 4 },
//               '& li': { mb: 1 },
//               '& blockquote': { 
//                 borderLeft: `4px solid ${primaryColor}`, 
//                 pl: 2, 
//                 py: 1, 
//                 my: 2, 
//                 fontStyle: 'italic',
//                 bgcolor: '#f3f4f6',
//                 borderRadius: 1
//               },
//               '& a': {
//                 color: primaryColor,
//                 textDecoration: 'none',
//                 fontWeight: 500,
//                 '&:hover': { textDecoration: 'underline' },
//               },
//             }}>
//               <ReactMarkdown
//                 remarkPlugins={[remarkGfm]}
//                 rehypePlugins={[rehypeRaw]}
//                 components={{
//                   iframe: ({ src, title, ...props }) => <YouTubeEmbed url={src} />,
//                 }}
//               >
//                 {post.content}
//               </ReactMarkdown>
//             </Box>
            
//             <Divider sx={{ my: 4 }} />
//             <Box sx={{ display: 'flex', gap: 1, alignItems: 'center' }}>
//               <Typography variant="body2" color="text.secondary">Share this article:</Typography>
//               <IconButton size="small" onClick={() => window.open(`https://www.facebook.com/sharer/sharer.php?u=${window.location.href}`)}>
//                 <FacebookIcon fontSize="small" />
//               </IconButton>
//               <IconButton size="small" onClick={() => window.open(`https://twitter.com/intent/tweet?url=${window.location.href}&text=${post.title}`)}>
//                 <TwitterIcon fontSize="small" />
//               </IconButton>
//               <IconButton size="small" onClick={() => window.open(`https://www.linkedin.com/shareArticle?url=${window.location.href}`)}>
//                 <LinkedInIcon fontSize="small" />
//               </IconButton>
//               <IconButton size="small" onClick={handleShare}>
//                 <ShareIcon fontSize="small" />
//               </IconButton>
//             </Box>
//           </Paper>
//         </Grid>

//         {/* Sidebar Column */}
//         <Grid item xs={12} md={4}>
//           <Stack spacing={3}>
//             <Paper sx={{ p: 3, borderRadius: 3, textAlign: 'center' }}>
//               <Avatar sx={{ width: 80, height: 80, mx: 'auto', mb: 2, bgcolor: primaryColor }}>
//                 FS
//               </Avatar>
//               <Typography variant="h6" fontWeight="700" gutterBottom>
//                 FreshSweeper
//               </Typography>
//               <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
//                 Helping Airbnb hosts automate turnovers and find reliable cleaners.
//               </Typography>
//               <Button variant="contained" fullWidth component={Link} to="/signup">
//                 Get Started
//               </Button>
//             </Paper>

//             <Paper sx={{ p: 3, borderRadius: 3 }}>
//               <Typography variant="h6" fontWeight="700" gutterBottom>
//                 Search
//               </Typography>
//               <TextField fullWidth size="small" placeholder="Search articles..." />
//             </Paper>

//             <Paper sx={{ p: 3, borderRadius: 3 }}>
//               <Typography variant="h6" fontWeight="700" gutterBottom>
//                 Recent Posts
//               </Typography>
//               <List>
//                 {recentPosts.map((recentPost, idx) => (
//                   <React.Fragment key={recentPost.id}>
//                     <ListItem component={Link} to={`/blog/${recentPost.slug}`} sx={{ px: 0, display: 'block' }}>
//                       <Typography variant="body2" fontWeight="600" sx={{ color: textPrimary }}>
//                         {recentPost.title}
//                       </Typography>
//                       <Typography variant="caption" color="text.secondary">
//                         {formatDate(recentPost.date)}
//                       </Typography>
//                     </ListItem>
//                     {idx < recentPosts.length - 1 && <Divider sx={{ my: 1 }} />}
//                   </React.Fragment>
//                 ))}
//               </List>
//             </Paper>
//           </Stack>
//         </Grid>
//       </Grid>
//     </Container>
//     </>
//   );
// };

// export default BlogPost;




import React, { useState, useEffect } from 'react';
import { 
  Container, Typography, Box, Chip, Paper, Breadcrumbs, 
  Link as MuiLink, CircularProgress, Grid, Divider, List, 
  ListItem, ListItemText, Avatar, Stack, IconButton, 
  TextField, Button, Alert, useTheme 
} from '@mui/material';
import { Link, useParams } from 'react-router-dom';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import rehypeRaw from 'rehype-raw';
import ShareIcon from '@mui/icons-material/Share';
import FacebookIcon from '@mui/icons-material/Facebook';
import TwitterIcon from '@mui/icons-material/Twitter';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import EmailIcon from '@mui/icons-material/Email';
import SearchIcon from '@mui/icons-material/Search';
import SEO from '../SEO';

// Determine API base URL (adjust to your FastAPI backend)
const API_URL = process.env.NODE_ENV === 'production' ? '' : 'https://www.freshsweeper.com';

const BlogPost = () => {
  const { slug } = useParams();
  const theme = useTheme();
  const [post, setPost] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [recentPosts, setRecentPosts] = useState([]);
  const [emailSubscribed, setEmailSubscribed] = useState(false);
  const [isVideoPost, setIsVideoPost] = useState(false);

  useEffect(() => {
    const fetchPost = async () => {
      try {
        // Fetch the current post by slug
        const res = await fetch(`${API_URL}/api/blog/posts/${slug}`);
        if (!res.ok) {
          if (res.status === 404) throw new Error('Post not found');
          throw new Error('Failed to fetch post');
        }
        const data = await res.json();
        setPost(data);

        // Check for YouTube embed
        if (data.content) {
          const hasYouTube = data.content.includes('youtube.com/embed') || 
                            data.content.includes('youtu.be') ||
                            data.content.includes('youtube.com/watch');
          setIsVideoPost(hasYouTube);
        }
      } catch (err) {
        console.error(err);
        setError(err.message);
        setPost(null);
      } finally {
        setLoading(false);
      }
    };

    fetchPost();
  }, [slug]);

  useEffect(() => {
    const fetchRecentPosts = async () => {
      if (!post) return;
      try {
        // Fetch all posts and exclude the current one
        const res = await fetch(`${API_URL}/api/blog/posts?limit=6`);
        if (!res.ok) throw new Error('Failed to fetch recent posts');
        const allPosts = await res.json();
        // Filter out the current post and take first 5
        const recent = allPosts.filter(p => p.slug !== slug).slice(0, 5);
        setRecentPosts(recent);
      } catch (err) {
        console.error('Could not load recent posts', err);
      }
    };
    if (post) fetchRecentPosts();
  }, [post, slug]);

  useEffect(() => {
    if (post) {
      document.title = `${post.title} | FreshSweeper Blog`;
      const metaDescription = document.querySelector('meta[name="description"]');
      if (metaDescription) {
        metaDescription.setAttribute('content', post.excerpt || post.content?.substring(0, 150));
      }
    }
  }, [post]);

  const formatDate = (dateString) => {
    if (!dateString) return '';
    const options = { year: 'numeric', month: 'long', day: 'numeric' };
    return new Date(dateString).toLocaleDateString(undefined, options);
  };

  const handleShare = () => {
    navigator.clipboard.writeText(window.location.href);
    alert('Link copied to clipboard!');
  };

  const handleSubscribe = () => {
    setEmailSubscribed(true);
    setTimeout(() => setEmailSubscribed(false), 3000);
  };

  const YouTubeEmbed = ({ url }) => {
    const getVideoId = (url) => {
      const regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=)([^#&?]*).*/;
      const match = url.match(regExp);
      return (match && match[2].length === 11) ? match[2] : null;
    };
    const videoId = getVideoId(url);
    if (!videoId) return null;
    return (
      <Box sx={{ position: 'relative', paddingBottom: '56.25%', height: 0, mb: 3, my: 4 }}>
        <iframe
          src={`https://www.youtube.com/embed/${videoId}`}
          title="YouTube video player"
          frameBorder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
          style={{
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            borderRadius: '12px'
          }}
        />
      </Box>
    );
  };

  if (loading) {
    return (
      <Container sx={{ py: 8, textAlign: 'center' }}>
        <CircularProgress />
      </Container>
    );
  }

  if (error || !post) {
    return (
      <Container sx={{ py: 8, textAlign: 'center' }}>
        <Typography variant="h4" gutterBottom>Post Not Found</Typography>
        <Typography color="text.secondary">The blog post you're looking for doesn't exist.</Typography>
        <MuiLink component={Link} to="/blog" sx={{ mt: 2, display: 'inline-block' }}>← Back to Blog</MuiLink>
      </Container>
    );
  }

  const primaryColor = theme?.palette?.primary?.main || '#3b82f6';
  const textPrimary = theme?.palette?.text?.primary || '#111827';

  return (
    <>
      <SEO 
        title={post.title}
        description={post.excerpt || post.content?.substring(0, 150).replace(/<[^>]*>/g, '')}
        image={post.image}
        type="article"
        canonical={`https://freshsweeper.com/blog/${post.slug}`}
      />
      <Container maxWidth="xl" sx={{ py: 4 }}>
        <Breadcrumbs separator={<NavigateNextIcon fontSize="small" />} sx={{ mb: 3 }}>
          <MuiLink component={Link} to="/" color="inherit">Home</MuiLink>
          <MuiLink component={Link} to="/blog" color="inherit">Blog</MuiLink>
          <Typography color="text.primary">{post.title}</Typography>
        </Breadcrumbs>

        <Grid container spacing={4}>
          {/* Main Content Column */}
          <Grid item xs={12} md={8}>
            <Paper sx={{ p: 4, borderRadius: 3 }}>
              <Chip label={post.category} sx={{ mb: 2 }} />
              <Typography variant="h3" sx={{ fontWeight: 800, mb: 2 }}>
                {post.title}
              </Typography>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 3, flexWrap: 'wrap' }}>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                  <Avatar sx={{ width: 32, height: 32, bgcolor: primaryColor }}>
                    {post.author?.charAt(0) || 'F'}
                  </Avatar>
                  <Typography variant="body2">By {post.author || 'FreshSweeper Team'}</Typography>
                </Box>
                <Typography variant="body2" color="text.secondary">•</Typography>
                <Typography variant="body2" color="text.secondary">{formatDate(post.date)}</Typography>
                <Typography variant="body2" color="text.secondary">•</Typography>
                <Typography variant="body2" color="text.secondary">5 min read</Typography>
              </Box>

              {!isVideoPost && post.image && (
                <Box
                  component="img"
                  src={post.image}
                  alt={post.title}
                  sx={{ width: '100%', borderRadius: 2, mb: 4 }}
                />
              )}

              <Box sx={{ 
                '& h1': { fontSize: '2.5rem', fontWeight: 700, mb: 2 },
                '& h2': { fontSize: '2rem', fontWeight: 700, mt: 4, mb: 2 },
                '& h3': { fontSize: '1.5rem', fontWeight: 600, mt: 3, mb: 1.5 },
                '& p': { lineHeight: 1.8, mb: 2 },
                '& ul, & ol': { mb: 2, pl: 4 },
                '& li': { mb: 1 },
                '& blockquote': { 
                  borderLeft: `4px solid ${primaryColor}`, 
                  pl: 2, 
                  py: 1, 
                  my: 2, 
                  fontStyle: 'italic',
                  bgcolor: '#f3f4f6',
                  borderRadius: 1
                },
                '& a': {
                  color: primaryColor,
                  textDecoration: 'none',
                  fontWeight: 500,
                  '&:hover': { textDecoration: 'underline' },
                },
              }}>
                <ReactMarkdown
                  remarkPlugins={[remarkGfm]}
                  rehypePlugins={[rehypeRaw]}
                  components={{
                    iframe: ({ src, ...props }) => <YouTubeEmbed url={src} />,
                  }}
                >
                  {post.content}
                </ReactMarkdown>
              </Box>

              <Divider sx={{ my: 4 }} />
              <Box sx={{ display: 'flex', gap: 1, alignItems: 'center' }}>
                <Typography variant="body2" color="text.secondary">Share this article:</Typography>
                <IconButton size="small" onClick={() => window.open(`https://www.facebook.com/sharer/sharer.php?u=${window.location.href}`)}>
                  <FacebookIcon fontSize="small" />
                </IconButton>
                <IconButton size="small" onClick={() => window.open(`https://twitter.com/intent/tweet?url=${window.location.href}&text=${post.title}`)}>
                  <TwitterIcon fontSize="small" />
                </IconButton>
                <IconButton size="small" onClick={() => window.open(`https://www.linkedin.com/shareArticle?url=${window.location.href}`)}>
                  <LinkedInIcon fontSize="small" />
                </IconButton>
                <IconButton size="small" onClick={handleShare}>
                  <ShareIcon fontSize="small" />
                </IconButton>
              </Box>
            </Paper>
          </Grid>

          {/* Sidebar Column */}
          <Grid item xs={12} md={4}>
            <Stack spacing={3}>
              <Paper sx={{ p: 3, borderRadius: 3, textAlign: 'center' }}>
                <Avatar sx={{ width: 80, height: 80, mx: 'auto', mb: 2, bgcolor: primaryColor }}>
                  FS
                </Avatar>
                <Typography variant="h6" fontWeight="700" gutterBottom>
                  FreshSweeper
                </Typography>
                <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
                  Helping Airbnb hosts automate turnovers and find reliable cleaners.
                </Typography>
                <Button variant="contained" fullWidth component={Link} to="/signup">
                  Get Started
                </Button>
              </Paper>

              <Paper sx={{ p: 3, borderRadius: 3 }}>
                <Typography variant="h6" fontWeight="700" gutterBottom>
                  Search
                </Typography>
                <TextField fullWidth size="small" placeholder="Search articles..." />
              </Paper>

              <Paper sx={{ p: 3, borderRadius: 3 }}>
                <Typography variant="h6" fontWeight="700" gutterBottom>
                  Recent Posts
                </Typography>
                <List>
                  {recentPosts.map((recentPost, idx) => (
                    <React.Fragment key={recentPost.id}>
                      <ListItem component={Link} to={`/blog/${recentPost.slug}`} sx={{ px: 0, display: 'block' }}>
                        <Typography variant="body2" fontWeight="600" sx={{ color: textPrimary }}>
                          {recentPost.title}
                        </Typography>
                        <Typography variant="caption" color="text.secondary">
                          {formatDate(recentPost.date)}
                        </Typography>
                      </ListItem>
                      {idx < recentPosts.length - 1 && <Divider sx={{ my: 1 }} />}
                    </React.Fragment>
                  ))}
                </List>
              </Paper>
            </Stack>
          </Grid>
        </Grid>
      </Container>
    </>
  );
};

export default BlogPost;






// import React, { useState, useEffect } from 'react';
// import { 
//   Container, Typography, Box, Chip, Paper, Breadcrumbs, 
//   Link as MuiLink, CircularProgress, Grid, Divider, List, 
//   ListItem, ListItemText, Avatar, Stack, IconButton, 
//   TextField, Button, Alert 
// } from '@mui/material';
// import { Link, useParams } from 'react-router-dom';
// import NavigateNextIcon from '@mui/icons-material/NavigateNext';
// import ReactMarkdown from 'react-markdown';
// import remarkGfm from 'remark-gfm';
// import rehypeRaw from 'rehype-raw';
// import ShareIcon from '@mui/icons-material/Share';
// import FacebookIcon from '@mui/icons-material/Facebook';
// import TwitterIcon from '@mui/icons-material/Twitter';
// import LinkedInIcon from '@mui/icons-material/LinkedIn';
// import EmailIcon from '@mui/icons-material/Email';
// import SearchIcon from '@mui/icons-material/Search';
// import COLORS from '../colors';

// const BlogPost = () => {
//   const { slug } = useParams();
//   const [post, setPost] = useState(null);
//   const [loading, setLoading] = useState(true);
//   const [recentPosts, setRecentPosts] = useState([]);
//   const [emailSubscribed, setEmailSubscribed] = useState(false);

//   useEffect(() => {
//     const savedPosts = localStorage.getItem('freshsweeper_blog_posts');
//     if (savedPosts) {
//       const posts = JSON.parse(savedPosts);
//       const foundPost = posts.find(p => p.slug === slug);
//       setPost(foundPost);
      
//       // Get recent posts (excluding current)
//       const recent = posts.filter(p => p.slug !== slug).slice(0, 5);
//       setRecentPosts(recent);
//     }
//     setLoading(false);
//   }, [slug]);

//   // Update page title for SEO
//   useEffect(() => {
//     if (post) {
//       document.title = `${post.title} | FreshSweeper Blog`;
//       const metaDescription = document.querySelector('meta[name="description"]');
//       if (metaDescription) {
//         metaDescription.setAttribute('content', post.excerpt || post.content.substring(0, 150));
//       }
//     }
//   }, [post]);

//   const formatDate = (dateString) => {
//     const options = { year: 'numeric', month: 'long', day: 'numeric' };
//     return new Date(dateString).toLocaleDateString(undefined, options);
//   };

//   const handleShare = () => {
//     navigator.clipboard.writeText(window.location.href);
//     alert('Link copied to clipboard!');
//   };

//   const handleSubscribe = () => {
//     setEmailSubscribed(true);
//     setTimeout(() => setEmailSubscribed(false), 3000);
//   };

//   const YouTubeEmbed = ({ url }) => {
//     const getVideoId = (url) => {
//       const regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=)([^#&?]*).*/;
//       const match = url.match(regExp);
//       return (match && match[2].length === 11) ? match[2] : null;
//     };
  
//     const videoId = getVideoId(url);
//     if (!videoId) return null;
  
//     return (
//       <Box sx={{ position: 'relative', paddingBottom: '56.25%', height: 0, mb: 3, my: 4 }}>
//         <iframe
//           src={`https://www.youtube.com/embed/${videoId}`}
//           title="YouTube video player"
//           frameBorder="0"
//           allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
//           allowFullScreen
//           style={{
//             position: 'absolute',
//             top: 0,
//             left: 0,
//             width: '100%',
//             height: '100%',
//             borderRadius: '12px'
//           }}
//         />
//       </Box>
//     );
//   };

//   if (loading) {
//     return (
//       <Container sx={{ py: 8, textAlign: 'center' }}>
//         <CircularProgress />
//       </Container>
//     );
//   }

//   if (!post) {
//     return (
//       <Container sx={{ py: 8, textAlign: 'center' }}>
//         <Typography variant="h4" gutterBottom>Post Not Found</Typography>
//         <Typography color="text.secondary">The blog post you're looking for doesn't exist.</Typography>
//         <MuiLink component={Link} to="/blog" sx={{ mt: 2, display: 'inline-block' }}>← Back to Blog</MuiLink>
//       </Container>
//     );
//   }

//   return (
//     <Container maxWidth="xl" sx={{ py: 4 }}>
//       <Breadcrumbs separator={<NavigateNextIcon fontSize="small" />} sx={{ mb: 3 }}>
//         <MuiLink component={Link} to="/" color="inherit">Home</MuiLink>
//         <MuiLink component={Link} to="/blog" color="inherit">Blog</MuiLink>
//         <Typography color="text.primary">{post.title}</Typography>
//       </Breadcrumbs>

//       {/* Two Column Layout */}
//       <Grid container spacing={4}>
//         {/* Main Content Column - Left */}
//         <Grid item xs={12} md={8}>
//           <Paper sx={{ p: 4, borderRadius: 3 }}>
//             <Chip label={post.category} sx={{ mb: 2 }} />
//             <Typography variant="h3" sx={{ fontWeight: 800, mb: 2 }}>
//               {post.title}
//             </Typography>
            
//             <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 3, flexWrap: 'wrap' }}>
//               <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
//                 <Avatar sx={{ width: 32, height: 32, bgcolor: COLORS.primary }}>
//                   {post.author?.charAt(0) || 'F'}
//                 </Avatar>
//                 <Typography variant="body2">By {post.author || 'FreshSweeper Team'}</Typography>
//               </Box>
//               <Typography variant="body2" color="text.secondary">•</Typography>
//               <Typography variant="body2" color="text.secondary">{formatDate(post.date)}</Typography>
//               <Typography variant="body2" color="text.secondary">•</Typography>
//               <Typography variant="body2" color="text.secondary">5 min read</Typography>
//             </Box>
            
//             {post.image && (
//               <Box
//                 component="img"
//                 src={post.image}
//                 alt={post.title}
//                 sx={{ width: '100%', borderRadius: 2, mb: 4 }}
//               />
//             )}
            
//             <Box sx={{ 
//               '& h1': { fontSize: '2.5rem', fontWeight: 700, mb: 2 },
//               '& h2': { fontSize: '2rem', fontWeight: 700, mt: 4, mb: 2 },
//               '& h3': { fontSize: '1.5rem', fontWeight: 600, mt: 3, mb: 1.5 },
//               '& p': { lineHeight: 1.8, mb: 2 },
//               '& ul, & ol': { mb: 2, pl: 4 },
//               '& li': { mb: 1 },
//               '& blockquote': { 
//                 borderLeft: '4px solid #3b82f6', 
//                 pl: 2, 
//                 py: 1, 
//                 my: 2, 
//                 fontStyle: 'italic',
//                 bgcolor: '#f3f4f6',
//                 borderRadius: 1
//               },
//               '& pre': { 
//                 bgcolor: '#1f2937', 
//                 p: 2, 
//                 borderRadius: 2, 
//                 overflow: 'auto',
//                 color: '#e5e7eb'
//               },
//               '& code': { 
//                 bgcolor: '#f3f4f6', 
//                 px: 1, 
//                 py: 0.5, 
//                 borderRadius: 1,
//                 fontFamily: 'monospace'
//               },
//               '& a': {
//                 color: COLORS.primary,
//                 textDecoration: 'none',
//                 fontWeight: 500,
//                 '&:hover': {
//                   textDecoration: 'underline',
//                 },
//               },
//               '& a.button': {
//                 display: 'inline-block',
//                 padding: '10px 20px',
//                 backgroundColor: '#3b82f6',
//                 color: 'white',
//                 borderRadius: '8px',
//                 '&:hover': {
//                   backgroundColor: '#2563eb',
//                   textDecoration: 'none',
//                 },
//               },
//             }}>
//               <ReactMarkdown
//                 remarkPlugins={[remarkGfm]}
//                 rehypePlugins={[rehypeRaw]}
//                 components={{
//                   img: ({ node, src, alt, ...props }) => (
//                     <img 
//                       src={src} 
//                       alt={alt} 
//                       style={{
//                         maxWidth: '100%',
//                         height: 'auto',
//                         maxHeight: '400px',
//                         width: 'auto',
//                         borderRadius: '8px',
//                         objectFit: 'cover',
//                         margin: '1rem 0',
//                       }}
//                       {...props}
//                     />
//                   ),
//                   iframe: ({ src, title, ...props }) => {
//                     return <YouTubeEmbed url={src} />;
//                   }
//                 }}
//               >
//                 {post.content}
//               </ReactMarkdown>
//             </Box>
            
//             {/* Share Buttons */}
//             <Divider sx={{ my: 4 }} />
//             <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: 2 }}>
//               <Box sx={{ display: 'flex', gap: 1, alignItems: 'center' }}>
//                 <Typography variant="body2" color="text.secondary">Share this article:</Typography>
//                 <IconButton size="small" onClick={() => window.open(`https://www.facebook.com/sharer/sharer.php?u=${window.location.href}`)}>
//                   <FacebookIcon fontSize="small" />
//                 </IconButton>
//                 <IconButton size="small" onClick={() => window.open(`https://twitter.com/intent/tweet?url=${window.location.href}&text=${post.title}`)}>
//                   <TwitterIcon fontSize="small" />
//                 </IconButton>
//                 <IconButton size="small" onClick={() => window.open(`https://www.linkedin.com/shareArticle?url=${window.location.href}`)}>
//                   <LinkedInIcon fontSize="small" />
//                 </IconButton>
//                 <IconButton size="small" onClick={handleShare}>
//                   <ShareIcon fontSize="small" />
//                 </IconButton>
//               </Box>
//             </Box>
//           </Paper>
//         </Grid>

//         {/* Sidebar Column - Right */}
//         <Grid item xs={12} md={4}>
//           <Stack spacing={3}>
//             {/* About Card */}
//             <Paper sx={{ p: 3, borderRadius: 3, textAlign: 'center' }}>
//               <Avatar sx={{ width: 80, height: 80, mx: 'auto', mb: 2, bgcolor: COLORS.primary }}>
//                 FS
//               </Avatar>
//               <Typography variant="h6" fontWeight="700" gutterBottom>
//                 FreshSweeper
//               </Typography>
//               <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
//                 Helping Airbnb hosts automate turnovers and find reliable cleaners.
//               </Typography>
//               <Button variant="contained" fullWidth component={Link} to="/signup">
//                 Get Started
//               </Button>
//             </Paper>

//             {/* Search Box */}
//             <Paper sx={{ p: 3, borderRadius: 3 }}>
//               <Typography variant="h6" fontWeight="700" gutterBottom>
//                 Search
//               </Typography>
//               <TextField
//                 fullWidth
//                 size="small"
//                 placeholder="Search articles..."
//                 InputProps={{
//                   endAdornment: <IconButton size="small"><SearchIcon /></IconButton>
//                 }}
//               />
//             </Paper>

//             {/* Recent Posts */}
//             <Paper sx={{ p: 3, borderRadius: 3 }}>
//               <Typography variant="h6" fontWeight="700" gutterBottom>
//                 Recent Posts
//               </Typography>
//               <List>
//                 {recentPosts.map((recentPost, idx) => (
//                   <React.Fragment key={recentPost.id}>
//                     <ListItem 
//                       component={Link} 
//                       to={`/blog/${recentPost.slug}`} 
//                       sx={{ 
//                         px: 0, 
//                         textDecoration: 'none', 
//                         display: 'block',
//                         '&:hover': { bgcolor: 'transparent' } 
//                       }}
//                     >
//                       <Typography variant="body2" fontWeight="600" sx={{ color: COLORS.text.primary }}>
//                         {recentPost.title}
//                       </Typography>
//                       <Typography variant="caption" color="text.secondary">
//                         {formatDate(recentPost.date)}
//                       </Typography>
//                     </ListItem>
//                     {idx < recentPosts.length - 1 && <Divider sx={{ my: 1 }} />}
//                   </React.Fragment>
//                 ))}
//               </List>
//             </Paper>

//             {/* Categories */}
//             <Paper sx={{ p: 3, borderRadius: 3 }}>
//               <Typography variant="h6" fontWeight="700" gutterBottom>
//                 Categories
//               </Typography>
//               <Stack spacing={1}>
//                 <Button component={Link} to="/blog?category=hosts" fullWidth sx={{ justifyContent: 'space-between', color: COLORS.text.primary, textTransform: 'none' }}>
//                   For Hosts <Chip label="12" size="small" />
//                 </Button>
//                 <Button component={Link} to="/blog?category=cleaners" fullWidth sx={{ justifyContent: 'space-between', color: COLORS.text.primary, textTransform: 'none' }}>
//                   For Cleaners <Chip label="8" size="small" />
//                 </Button>
//                 <Button component={Link} to="/blog?category=guides" fullWidth sx={{ justifyContent: 'space-between', color: COLORS.text.primary, textTransform: 'none' }}>
//                   Guides <Chip label="5" size="small" />
//                 </Button>
//               </Stack>
//             </Paper>

//             {/* Newsletter Signup */}
//             <Paper sx={{ p: 3, borderRadius: 3, bgcolor: '#f0f9ff' }}>
//               <Typography variant="h6" fontWeight="700" gutterBottom>
//                 📧 Weekly Newsletter
//               </Typography>
//               <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
//                 Get the latest tips and articles delivered to your inbox.
//               </Typography>
//               {emailSubscribed ? (
//                 <Alert severity="success" onClose={() => setEmailSubscribed(false)}>Subscribed! Check your email.</Alert>
//               ) : (
//                 <>
//                   <TextField fullWidth size="small" placeholder="Your email" type="email" sx={{ mb: 2 }} />
//                   <Button variant="contained" fullWidth onClick={handleSubscribe}>
//                     Subscribe
//                   </Button>
//                 </>
//               )}
//             </Paper>

//             {/* Advertisement / CTA */}
//             <Paper sx={{ p: 3, borderRadius: 3, textAlign: 'center', bgcolor: COLORS.primary, color: 'white' }}>
//               <Typography variant="h6" fontWeight="700" gutterBottom>
//                 Ready to Automate?
//               </Typography>
//               <Typography variant="body2" sx={{ mb: 2, opacity: 0.9 }}>
//                 Join thousands of hosts using FreshSweeper
//               </Typography>
//               <Button variant="contained" sx={{ bgcolor: 'white', color: COLORS.primary }} component={Link} to="/signup">
//                 Start Free Trial
//               </Button>
//             </Paper>

//             {/* Follow Us */}
//             <Paper sx={{ p: 3, borderRadius: 3 }}>
//               <Typography variant="h6" fontWeight="700" gutterBottom>
//                 Follow Us
//               </Typography>
//               <Box sx={{ display: 'flex', gap: 2, justifyContent: 'center' }}>
//                 <IconButton href="https://facebook.com" target="_blank">
//                   <FacebookIcon />
//                 </IconButton>
//                 <IconButton href="https://twitter.com" target="_blank">
//                   <TwitterIcon />
//                 </IconButton>
//                 <IconButton href="https://linkedin.com" target="_blank">
//                   <LinkedInIcon />
//                 </IconButton>
//                 <IconButton href="mailto:blog@freshsweeper.com">
//                   <EmailIcon />
//                 </IconButton>
//               </Box>
//             </Paper>
//           </Stack>
//         </Grid>
//       </Grid>
//     </Container>
//   );
// };

// export default BlogPost;

